import { render, staticRenderFns } from "./OrientationDefault.vue?vue&type=template&id=f3a55cde&scoped=true&"
import script from "./OrientationDefault.vue?vue&type=script&lang=js&"
export * from "./OrientationDefault.vue?vue&type=script&lang=js&"
import style0 from "./OrientationDefault.vue?vue&type=style&index=0&id=f3a55cde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a55cde",
  null
  
)

export default component.exports